module.exports = __webpack_public_path__ + "static/img/books-stack-of-three-blue.3153a715.svg";